import * as Yup from 'yup';

import { ERRORS_TEXTS, FIELDS_LIMITS } from '../../../../../../const/validation';

const optionalPositiveIntegerSchema = Yup.number()
  .transform((v, o) => (o === '' ? null : v))
  .nullable()
  .typeError(ERRORS_TEXTS.integer)
  .integer(ERRORS_TEXTS.integer)
  .positive(ERRORS_TEXTS.positive);

const optionalPositiveNumberSchema = Yup.number()
  .transform((v, o) => (o === '' ? null : v))
  .nullable()
  .typeError(ERRORS_TEXTS.number)
  .positive(ERRORS_TEXTS.positive);

export const createValidationSchema = (isStarted: boolean) =>
  Yup.object({
    title: Yup.string().required(ERRORS_TEXTS.required),
    tagline: Yup.string().max(FIELDS_LIMITS.tagline, ERRORS_TEXTS.tagline),
    author: Yup.object().required(ERRORS_TEXTS.required),
    currency: Yup.object().required(ERRORS_TEXTS.required),
    period: Yup.object().required(ERRORS_TEXTS.required),
    category: Yup.object().required(ERRORS_TEXTS.required),
    recalcMode: Yup.object().required(ERRORS_TEXTS.required),
    minSumma: Yup.number().positive(ERRORS_TEXTS.positive).required(ERRORS_TEXTS.required),
    recommendedAmount: Yup.number()
      .transform((v, o) => (o === '' ? null : v))
      .nullable()
      .positive(ERRORS_TEXTS.positive),
    capacity: Yup.number()
      .transform((v, o) => (o === '' ? null : v))
      .nullable()
      .positive(ERRORS_TEXTS.positive),
    estimatedProfit: Yup.number()
      .transform((v, o) => (o === '' ? null : v))
      .nullable()
      .positive(ERRORS_TEXTS.positive),
    estimatedTradesPerWeek: Yup.number()
      .transform((v, o) => (o === '' ? null : v))
      .nullable()
      .positive(ERRORS_TEXTS.positive),
    maxInstrumentWeight: Yup.number().positive(ERRORS_TEXTS.positive),
    maxSignalWeight: Yup.number()
      .transform((v, o) => (o === '' ? null : v))
      .nullable()
      .positive(ERRORS_TEXTS.positive),
    leverage: Yup.number().min(0, ERRORS_TEXTS.positive),
    shortLeverage: Yup.number()
      .transform((v, o) => (o === '' ? null : v))
      .nullable()
      .min(0, ERRORS_TEXTS.positive),
    codeDWH: isStarted ? optionalPositiveIntegerSchema.required(ERRORS_TEXTS.required) : optionalPositiveIntegerSchema,
    productPlanKO: isStarted
      ? optionalPositiveNumberSchema.required(ERRORS_TEXTS.required)
      : optionalPositiveNumberSchema,
    tariffAf: Yup.object()
      .nullable()
      .when('isAutofollow', { is: true, then: (schema) => schema.required(ERRORS_TEXTS.required) }),
    tariffAc: Yup.object()
      .nullable()
      .when('isAutoconsult', { is: true, then: (schema) => schema.required(ERRORS_TEXTS.required) }),
  });
